import { useBrandStore } from '@bv/stores/brand';
import { useUserStore } from '@bv/stores/user';
import { computed } from 'vue';

export const isOwner = computed<boolean>(() => {
  const userStore = useUserStore();

  return !!userStore.currentWorkspace?.is_owner;
});

export const workspaceHasZohoBilling = computed(() => {
  const userStore = useUserStore();

  return !!userStore.currentWorkspace?.services?.some((s) => s?.billing_mode === 'zoho');
});

export const isOwnerAndZohoBilling = computed<boolean>(() => isOwner.value && workspaceHasZohoBilling.value);

export const isDefaultBrand = computed(() => {
  const brandStore = useBrandStore();
  return !!brandStore.config?.isDefault;
});

export const canAccessNewBillingFeatures = computed(() => isDefaultBrand.value && isOwnerAndZohoBilling.value);

export const canAccessIntegrations = computed(() => isDefaultBrand.value && isOwner.value);
